class ComponentCountrySelector extends HTMLElement {
  constructor() {
    super()
    this.openButtons = document.querySelectorAll(
      '[data-target="country-selector"]'
    )
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector('[data-target="disclosure"]'),
      panel: this.querySelector('ul'),
    }
    this.form = this.querySelector('form')
    this.elements.button.addEventListener('click', this.openSelector.bind(this))
    this.elements.button.addEventListener(
      'focusout',
      this.closeSelector.bind(this)
    )
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    )
  }

  connectedCallback() {
    this.initRedirect()
    this.dialog = this.querySelector('dialog')
    this.openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.dialog.showModal()
      })
    })
    this.onSubmit()
  }

  initRedirect() {
    const isRedirected = localStorage.getItem('isRedirected')
    if (isRedirected === 'true') return
    const currentCountry = this.dataset.country
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          throw error
        }

        const region = window.Shopify.customerPrivacy.getRegion()
        const country = region.slice(0, 2)
        if (currentCountry === country) return
        const inputEl = this.querySelector('[name="country_code"]')
        inputEl.value = country
        localStorage.setItem('isRedirected', true)
        this.form.submit()
      }
    )
  }

  onSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()
      localStorage.setItem('isRedirected', true)
      this.form.submit()
    })
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false')
    this.elements.panel.setAttribute('hidden', true)
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.hidePanel()
    this.elements.button.focus()
  }

  onItemClick(event) {
    event.preventDefault()
    this.elements.input.value = event.currentTarget.dataset.value
    this.elements.button.querySelector('span').innerText =
      event.currentTarget.innerText
    this.hidePanel()
  }

  openSelector() {
    this.elements.button.focus()
    this.elements.panel.toggleAttribute('hidden')
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString()
    )
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel()
    }
  }
}

customElements.define('component-country-selector', ComponentCountrySelector)
